<template>
  <div class="footer">
    <div class="content">
      <div class="t3">
        <div @click="link('/home')">HOME</div>
        <div @click="link('/M3SERIES')">M3 SERIES</div>
        <div @click="link('/newProduct')">UPCOMING PRODUCTS</div>
        <div @click="link('/about')">ABOUT</div>
        <div @click="link('/contact')">DEALER NETWORK</div>
      </div>
      <div class="logo">
        <img src="@/assets/images/logo4.png" alt="">
      </div>
      <div class="t4">
        <span @click="goPrivacy(0)">Terms & Conditions</span>
        <span @click="goPrivacy(1)">Privacy Policy </span>
        <!-- <span @click="goPrivacy(2)">Cookie Policy</span> -->
      </div>
      <div class="t5">© 2025 TEWA MOTO</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FooterTemp',
    data () {
      return {

      }
    },
    mounted () {

    },
    methods: {
      link (path) {
        if (this.$route.path !== path) {
          this.$router.push(path).catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              throw err;
            }
          });
        }
      },
      goPrivacy (type) {
        // 检查是否已经是目标路由且参数相同
        if (this.$route.path === '/privacy' &&
          parseInt(this.$route.query.type) === type) {
          return;
        }

        this.$router.push({
          path: '/privacy',
          query: {
            type: type
          }
        }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
    }
  }
</script>

<style scoped lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=Tilt+Warp&display=swap');
  @media (min-width: 769px) {
    .footer {
      background: #000;
      color: #f3f3f3;
      display: flex;
      justify-content: center;
      text-align: center;
      padding: 22.22px 0;

      .content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        row-gap: 22px;
        font-family: "AlibabaPuHuiTi";

        .t1 {
          font-size: 13.88px;
          color: #4A4A4A;
        }

        .t2 {
          font-size: 13.88px;
          font-family: "Tilt Warp", cursive;
        }

        .t3 {
          display: flex;
          justify-content: center;
          column-gap: 20px;
          font-size: 13.88px;
          cursor: pointer;
        }

        .logo {
          width: 136px;
          text-align: center;

          img {
            width: 100%;
            height: auto;
          }
        }

        .t4 {
          display: flex;
          column-gap: 20px;
          color: #636363;
          font-size: 13.88px;
          cursor: pointer;
        }

        .t5 {
          color: #636363;
          font-size: 13.88px;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .footer {
      background: #000;
      color: #f3f3f3;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px 0;

      .content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        row-gap: 10px;

        .t1,
        .t2,
        .t3,
        .t4,
        .t5 {
          font-size: 10px;
        }

        .t1 {
          color: #4A4A4A;
        }

        .t3,
        {
        cursor: pointer;
        display: flex;
        column-gap: 10px;
      }

      .t4 {
        display: flex;
        column-gap: 10px;
      }

      .t4,
      .t5 {
        color: #636363;
      }

      .logo {
        width: 100px;
        text-align: center;

        img {
          width: 100%;
          height: auto;
        }
      }
    }
  }
  }
</style>